import { faUserSlash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Chip, Tooltip, Typography } from '@mui/material';
import type { GridRenderCellParams } from '@mui/x-data-grid';

import ponIcon from '@/assets/pondurance-horizontal-mini.svg';
import type { Organization } from '@/pages/Organizations';
import getDateTime from '@/utils/getDateTime.utils';

import type { UserRole } from './Users.types';

export const renderUserTypeCell = (params: GridRenderCellParams) => {
  const value = !!params.value;

  if (value) {
    return (
      <Tooltip title="Service Account - API access only, cannot login via Auth0">
        <Chip label="SERVICE" color="info" size="small" />
      </Tooltip>
    );
  }

  return <Chip label="USER" color="default" size="small" />;
};

export const renderRolesCell = (params: GridRenderCellParams) => {
  const value = params.value ?? [];

  const elements = value
    .slice(0, 3)
    .map((role: UserRole) => (
      <Chip
        label={role.name.toUpperCase()}
        key={role.role_id}
        sx={{ mr: '.25rem' }}
      />
    ));

  if (value.length > 3) {
    elements.push(
      <Chip label={`+${value.length - 3}`} key="more" sx={{ mr: '.25rem' }} />
    );
  }

  return elements;
};

export const renderOrganizationCountCell = (params: GridRenderCellParams) => {
  const organizations =
    (params.row as { organizations?: Organization[] }).organizations ?? [];

  return (
    <Tooltip
      arrow
      title={
        <Typography sx={{ fontSize: '0.875rem' }}>
          {organizations.map((o: Organization) => o.name).join(', ')}
        </Typography>
      }
      placement="top"
    >
      <Badge badgeContent={params.value ?? 0} color="info" />
    </Tooltip>
  );
};

export const renderUpdatedAtCell = (params: GridRenderCellParams) =>
  params.value ? getDateTime(params.value) : '';

export const renderLastSignInCell = (params: GridRenderCellParams) =>
  params.value ? getDateTime(params.value) : '';

export const renderInternalCell = (params: GridRenderCellParams) =>
  params.value ? (
    <img src={ponIcon} alt="Pondurance" style={{ width: '1rem' }} />
  ) : (
    <FontAwesomeIcon icon={faUserSlash} size="lg" />
  );

export const renderActiveCell = (params: GridRenderCellParams) =>
  params.value ? <Chip label="Yes" color="success" /> : <Chip label="No" />;
